const hedgedStatus = ['hedged', 'unhedged'];

export { hedgedStatus };
